module.exports = __webpack_public_path__ + "img/s-mob-5.1cb5c0e9.webp";